import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLocalizedPath } from '../../routes/useLanguageSync';
import { Service } from '../../types';
import styles from './ServiceCard.module.css';

interface ServiceCardProps {
  service: Service;
}

const ServiceCard: React.FC<ServiceCardProps> = ({ service }) => {
  const { t } = useTranslation();
  const getPath = useLocalizedPath();

  return (
    <div className={styles.card}>
      <div
        className={styles.accentBar}
        style={{ backgroundColor: service.accentColor }}
      />
      <div className={styles.content}>
        <img
          src={service.logo}
          alt={t(service.nameKey)}
          className={styles.logo}
        />
        <h3 className={styles.name}>{t(service.nameKey)}</h3>
        <p className={styles.tagline}>{t(service.taglineKey)}</p>
        <p className={styles.description}>{t(service.shortDescriptionKey)}</p>
        <Link
          to={getPath('serviceDetail', { slug: service.slug })}
          className={styles.link}
          style={{ color: service.accentColor }}
        >
          {t('services.learnMore')} &rarr;
        </Link>
      </div>
    </div>
  );
};

export default ServiceCard;
